/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceRoleDefinition } from './ServiceRoleDefinition';
import {
    ServiceRoleDefinitionFromJSON,
    ServiceRoleDefinitionFromJSONTyped,
    ServiceRoleDefinitionToJSON,
    ServiceRoleDefinitionToJSONTyped,
} from './ServiceRoleDefinition';

/**
 * 
 * @export
 * @interface ConfigurationServiceRoleMetadata
 */
export interface ConfigurationServiceRoleMetadata {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationServiceRoleMetadata
     */
    taskId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationServiceRoleMetadata
     */
    workAccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationServiceRoleMetadata
     */
    isPmkTask?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationServiceRoleMetadata
     */
    taskName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationServiceRoleMetadata
     */
    techId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationServiceRoleMetadata
     */
    stepMetadataType: string;
    /**
     * 
     * @type {Array<ServiceRoleDefinition>}
     * @memberof ConfigurationServiceRoleMetadata
     */
    serviceRoleList?: Array<ServiceRoleDefinition>;
}

/**
 * Check if a given object implements the ConfigurationServiceRoleMetadata interface.
 */
export function instanceOfConfigurationServiceRoleMetadata(value: object): value is ConfigurationServiceRoleMetadata {
    if (!('stepMetadataType' in value) || value['stepMetadataType'] === undefined) return false;
    return true;
}

export function ConfigurationServiceRoleMetadataFromJSON(json: any): ConfigurationServiceRoleMetadata {
    return ConfigurationServiceRoleMetadataFromJSONTyped(json, false);
}

export function ConfigurationServiceRoleMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationServiceRoleMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'workAccess': json['workAccess'] == null ? undefined : json['workAccess'],
        'isPmkTask': json['isPmkTask'] == null ? undefined : json['isPmkTask'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'techId': json['techId'] == null ? undefined : json['techId'],
        'stepMetadataType': json['stepMetadataType'],
        'serviceRoleList': json['serviceRoleList'] == null ? undefined : ((json['serviceRoleList'] as Array<any>).map(ServiceRoleDefinitionFromJSON)),
    };
}

export function ConfigurationServiceRoleMetadataToJSON(json: any): ConfigurationServiceRoleMetadata {
    return ConfigurationServiceRoleMetadataToJSONTyped(json, false);
}

export function ConfigurationServiceRoleMetadataToJSONTyped(value?: ConfigurationServiceRoleMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'workAccess': value['workAccess'],
        'isPmkTask': value['isPmkTask'],
        'taskName': value['taskName'],
        'techId': value['techId'],
        'stepMetadataType': value['stepMetadataType'],
        'serviceRoleList': value['serviceRoleList'] == null ? undefined : ((value['serviceRoleList'] as Array<any>).map(ServiceRoleDefinitionToJSON)),
    };
}

